export * from './BasicInfo/BasicInfo'
export * from './Password/Password'
export * from './EmailVerification/EmailVerification'